/**
 * Copyright (C) 2020, Merkur India.
 *
 * The program(s) herein may be used and/or copied only with
 * the written permission of Merkur India. or in accordance with
 * the terms and conditions stipulated in the agreement/contract
 * under which the program(s) have been supplied.
 *
 * $Id: BSGameComponentFactory.ts ,v 1.0 Exp $
 * Date Author Changes
 * 3 July 2020 Sujata Nethani Created
 *
 */ 
namespace Game {
    import GameComponentFactory = Game.GameComponentFactory;
    import BaseGameState = States.BaseGameState;
    import GameState = States.GameState;
    import AssetPreloadState = States.BSAssetPreloadState;
    /**
     * Factory class to create all your game components and states
     */
    export class BSGameComponentFactory extends GameComponentFactory {
        /**
         * Creates the gameDescriptorDTO to describe the game
         * e.g. lineSelection,Scatter,Freegames etc.
         */
        public createGameDescriptorDTO(): DTO.GameDescriptorDTO {
            return new DTO.SKGameDescriptorDTO();
        }

        /**
         * WagerFacade to display wager sums etc.
         * @param phaserGame
         * @param controller
         * @param portalAPI
         */
        public createWagerFacade(phaserGame: AdpPhaserGame, controller: GameFlow.Controller, portalAPI: Portal.PortalAPI): Wager.WagerFacade {
            return new Wager.SplitCoinWagerFacade(phaserGame, controller, portalAPI);
        }

        /**
         * The Basegamestate of the game
         */
        public createBaseGameState():BaseGameState{
            if (Util.DeviceInformation.isMobile()) {
                return new States.BSSDBaseGameState();
            } else {
                return new States.BSHRBaseGameState();
            }
        }

        /**
         *
         * @param p_progressDisplay
         */
        public createGameAssetsLoadState(p_progressDisplay: Util.ProgressDisplay ): AssetPreloadState {
            return new States.BSAssetPreloadState(p_progressDisplay);
        }

        /**
         * Array of custom gamestates including FreegameStates and Addongames
         * @param adpgame
         */
        public createCustomGameStates(adpgame:AdpGame):Array<GameState>{
            return [];
        }

        public createPhaserGame(width?: number | string, height?: number | string, renderer: number = Phaser.AUTO, parent?: any, transparent: boolean = false, antialias: boolean = true) {
            if (Util.DeviceInformation.isMobile() || Util.DeviceInformation.isIPadInDesktopDisguise()) {
                return new AdpPhaserGame(width, height, Phaser.CANVAS, parent, transparent, antialias);
            } else {
                return new AdpPhaserGame(width, height, renderer, parent, transparent, antialias);
            }
        }
    }
}
